$(document).ready(function () {

    window.prettyPrint && prettyPrint()

    // Animated thumbnails
    var $animThumb = $('#aniimated-thumbnials');
    if ($animThumb.length) {
        $animThumb.justifiedGallery({
            border: 6
        }).on('jg.complete', function () {
            $animThumb.lightGallery({
                thumbnail: true
            });
        });
    };

    //thumbnails without animation
    var $thumb = $('#thumbnials-without-animation');
    if ($thumb.length) {
        $thumb.justifiedGallery({
            border: 6
        }).on('jg.complete', function () {
            $thumb.lightGallery({
                thumbnail: true,
                animateThumb: false,
                showThumbByDefault: false
            });
        });
    };

    // Fixed size
    $('#fixed-size').lightGallery({
        width: '700px',
        height: '470px',
        mode: 'lg-fade',
        addClass: 'fixed-size',
        counter: false,
        download: false,
        startClass: '',
        enableSwipe: false,
        enableDrag: false,
        speed: 500
    });

    $('#html5-videos').lightGallery({
        thumbnail: false
    });

    $('#html5-videos-videojs').lightGallery({
        videojs: true
    });

    $('#videos').lightGallery();
    $('#videos-without-poster').lightGallery();
    $('#video-player-param').lightGallery({
        youtubePlayerParams: {
            modestbranding: 1,
            showinfo: 0,
            rel: 0,
            controls: 0
        },
        vimeoPlayerParams: {
            byline: 0,
            portrait: 0,
            color: 'A90707'
        }
    });

    $('#video-thumbnails').lightGallery({
        loadYoutubeThumbnail: true,
        youtubeThumbSize: 'default',
        loadVimeoThumbnail: true,
        vimeoThumbSize: 'thumbnail_medium'
    });

    $('#dynamic').on('click', function() {
        $(this).lightGallery({
            dynamic: true,
            dynamicEl: [{
                src: 'http://sachinchoolur.github.io/lightGallery/static/img/1.jpg',
                thumb: 'http://sachinchoolur.github.io/lightGallery/static/img/thumb-1.jpg',
                subHtml: '<h4>Fading Light</h4><p>Classic view from Rigwood Jetty on Coniston Water an old archive shot similar to an old post but a little later on.</p>'
            }, {
                src: 'http://sachinchoolur.github.io/lightGallery/static/img/2.jpg',
                thumb: 'http://sachinchoolur.github.io/lightGallery/static/img/thumb-2.jpg',
                subHtml: '<h4>Bowness Bay</h4><p>A beautiful Sunrise this morning taken En-route to Keswick not one as planned but I\'m extremely happy I was passing the right place at the right time....</p>'
            }, {
                src: 'http://sachinchoolur.github.io/lightGallery/static/img/13.jpg',
                thumb: 'http://sachinchoolur.github.io/lightGallery/static/img/thumb-13.jpg',
                subHtml: '<h4>Sunset Serenity</h4><p>A gorgeous Sunset tonight captured at Coniston Water....</p>'
            }, {
                src: 'http://sachinchoolur.github.io/lightGallery/static/img/3.jpg',
                thumb: 'http://sachinchoolur.github.io/lightGallery/static/img/thumb-3.jpg',
                subHtml: '<h4>Coniston Calmness</h4><p>Beautiful morning</p>'
            }]
        })
    });

    function customTransitions(trans) {
        $('#custom-transitions').lightGallery({
            mode: trans
        })
    }

    customTransitions('lg-slide');

    $('#select-trans').on('change', function () {
        $('#custom-transitions').data('lightGallery').destroy(true);
        customTransitions($(this).val());
    });

    function customEasing(ease) {
        $('#custom-easing').lightGallery({
            cssEasing: ease
        })
    }

    customEasing('cubic-bezier(0.680, -0.550, 0.265, 1.550)');

    $('#select-ease').on('change', function () {

        var val = $(this).val();
        prompt('You can copy cubic-bezier from here', val);

        $('#custom-easing').data('lightGallery').destroy(true);
        customEasing('cubic-bezier(' + val + ')');
    });

    // Custom events
    var $customEvents = $('#custom-events');
    $customEvents.lightGallery();

    var colours = ['rgb(33, 23, 26)', 'rgb(129, 87, 94)', 'rgb(156, 80, 67)', 'rgb(143, 101, 93)'];
    $customEvents.on('onBeforeSlide.lg', function (event, prevIndex, index) {
        $('.lg-outer').css('background-color', colours[index])
    });

    // Responsive images
    $('#responsive-images').lightGallery();
    $('#srcset-images').lightGallery();

    // methods
    var $methods = $('#methods');
    var slide = '<li class="col-xs-6 col-sm-4 col-md-3" data-src="../static/img/4.jpg">' +
        '<a href="">' +
        '<img class="img-responsive" src="../static/img/thumb-4.jpg">' +
        '<div class="demo-gallery-poster">' +
        '<img src="../static/img/zoom.png">' +
        '</div>' +
        '</a>' +
        '</li>';

    $methods.lightGallery();
    $('#appendSlide').on('click', function () {
        $methods.append(slide);
        $methods.data('lightGallery').destroy(true);
        $methods.lightGallery();
    });

    // iframe
    $('#open-website').lightGallery({
        selector: 'this'
    });

    // Google map
    $('#google-map').lightGallery({
        selector: 'this',
        iframeMaxWidth: '80%'
    });

    $('#captions').lightGallery();
    $('#hash').lightGallery();

    var $commentBox = $('#comment-box');
    $commentBox.lightGallery({
        appendSubHtmlTo: '.lg-item',
        addClass: 'fb-comments',
        mode: 'lg-fade',
        download: false,
        enableDrag: false,
        enableSwipe: false
    });
    $commentBox.on('onAfterSlide.lg', function (event, prevIndex, index) {
        if (!$('.lg-outer .lg-item').eq(index).attr('data-fb')) {
            try {
                $('.lg-outer .lg-item').eq(index).attr('data-fb', 'loaded');
                FB.XFBML.parse();
            } catch (err) {
                $(window).on('fbAsyncInit', function () {
                    $('.lg-outer .lg-item').eq(index).attr('data-fb', 'loaded');
                    FB.XFBML.parse();
                });
            }
        }
    });

    var $commentBoxSep = $('#comment-box-sep');
    $commentBoxSep.lightGallery({
        addClass: 'fb-comments',
        download: false,
        galleryId: 2
    });
    $commentBoxSep.on('onAfterAppendSubHtml.lg', function () {
        try {
            FB.XFBML.parse();
        } catch (err) {
            $(window).on('fbAsyncInit', function () {
                FB.XFBML.parse();
            });
        }
    });

});


    function galleryLangkawi() {
        $('#galleryLangkawi').lightGallery({
            dynamic: true,
            dynamicEl: [{
                src: '../gallery/Langkawi/IMG_3173.jpg',
                thumb: '../gallery/Langkawi/IMG_3173-t.jpg',
                subHtml: '<h4>Sunset</h4><p>Sunset at Langkawi.</p>'
            }, {
                src: '../gallery/Langkawi/IMG_0573.jpg',
                thumb: '../gallery/Langkawi/IMG_0573-t.jpg',
                subHtml: '<h4>Fabrication</h4><p>Sensor board fabrication.</p>'
            }, {
                src: '../gallery/Langkawi/IMG_0342.jpg',
                thumb: '../gallery/Langkawi/IMG_0342-t.jpg',
                subHtml: '<h4>Installation</h4><p>Sensor board installed to the water buoy.</p>'
            }, {
                src: '../gallery/Langkawi/IMG_3034.jpg',
                thumb: '../gallery/Langkawi/IMG_3034-t.jpg',
                subHtml: '<h4>Testing</h4><p>Water buoy tested in outdoor water tank.</p>'
            }, {
                src: '../gallery/Langkawi/IMG_0993.jpg',
                thumb: '../gallery/Langkawi/IMG_0993-t.jpg',
                subHtml: '<h4>Calibration</h4><p>Calibrating the sensors.</p>'
            }, {
                src: '../gallery/Langkawi/IMG_3153.jpg',
                thumb: '../gallery/Langkawi/IMG_3153-t.jpg',
                subHtml: '<h4>Deployment</h4><p>Water buoy being deployed at sea.</p>'
            }, {
                src: '../gallery/Langkawi/IMG_0922.jpg',
                thumb: '../gallery/Langkawi/IMG_0922-t.jpg',
                subHtml: '<h4>Buoy</h4><p>Water buoy taking water quality reading.</p>'
            }, {
                src: '../gallery/Langkawi/IMG_0931.jpg',
                thumb: '../gallery/Langkawi/IMG_0931-t.jpg',
                subHtml: '<h4>Buoy</h4><p>Water buoy taking water quality reading.</p>'
            }, {
                src: '../gallery/Langkawi/IMG_0924.jpg',
                thumb: '../gallery/Langkawi/IMG_0924-t.jpg',
                subHtml: '<h4>Panorama View</h4><p>Panoramic view of the fish cages.</p>'
            }]
        })
    }

    function galleryGreenhouseSgC() {
        $('#galleryGreenhouseSgC').lightGallery({
            dynamic: true,
            dynamicEl: [{
                src: '../gallery/Greenhouse/IMG_2855.jpg',
                thumb: '../gallery/Greenhouse/IMG_2855-t.jpg',
                subHtml: '<h4>Harumanis</h4><p>Greenhouse for Harumanis plantation.</p>'
            }, {
                src: '../gallery/Greenhouse/IMG_2820.jpg',
                thumb: '../gallery/Greenhouse/IMG_2820-t.jpg',
                subHtml: '<h4>Harumanis</h4><p>Greenhouse for Harumanis plantation.</p>'
            }, {
                src: '../gallery/Greenhouse/IMG_2822.jpg',
                thumb: '../gallery/Greenhouse/IMG_2822-t.jpg',
                subHtml: '<h4>Harumanis</h4><p>Greenhouse for Harumanis plantation.</p>'
            }, {
                src: '../gallery/Greenhouse/IMG_2835.jpg',
                thumb: '../gallery/Greenhouse/IMG_2835-t.jpg',
                subHtml: '<h4>Harumanis</h4><p>Greenhouse for Harumanis plantation.</p>'
            }, {
                src: '../gallery/Greenhouse/IMG_2837.jpg',
                thumb: '../gallery/Greenhouse/IMG_2837-t.jpg',
                subHtml: '<h4>Harumanis</h4><p>Greenhouse for Harumanis plantation.</p>'
            }, {
                src: '../gallery/Greenhouse/IMG_2843.jpg',
                thumb: '../gallery/Greenhouse/IMG_2843-t.jpg',
                subHtml: '<h4>Harumanis</h4><p>Greenhouse for Harumanis plantation.</p>'
            }, {
                src: '../gallery/Greenhouse/Picture1.jpg',
                thumb: '../gallery/Greenhouse/Picture1-t.jpg',
                subHtml: '<h4>Harumanis</h4><p>Greenhouse for Harumanis plantation.</p>'
            }]
        })
    }

    function floorplanCEASTech()
    {
        $('#floorplan-ceastech').lightGallery({
            selector: 'this',
            videoMaxWidth: '1620px',
            zoom: 'false'
        });
    }